import { doc, getDoc, setDoc } from 'firebase/firestore';
import Failure from '../../../core/Failure';
import { FirestoreCollections, firestore } from '../../../firebase.config';
import Domain from '../../models/Domain';
import { UserRole } from '@leedpulse-monorepo/enums';
import { Authentication } from '@leedpulse-monorepo/classes';

async function createDomain(
  payload: Domain,
  auth: Authentication
): Promise<void> {
  if (![UserRole.owner, UserRole.admin].includes(auth.role)) {
    throw new CreateDomainFailure('Unauthorized', 'unauthorized');
  }

  try {
    const domainDoc = payload;

    const domainDocData = domainDoc.toFirestore();
    const db = firestore;

    const domainDocRef = doc(db, FirestoreCollections.domains, domainDoc.id);
    const domainDocSnap = await getDoc(domainDocRef);

    if (domainDocSnap.exists()) {
      throw new CreateDomainFailure('Domain already exists', 'domain-exists');
    }

    await setDoc(domainDocRef, domainDocData);

    return;
  } catch (e) {
    console.log('error: ', e);
    throw new CreateDomainFailure();
  }
}

export class CreateDomainFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default createDomain;
